'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.senderTypeToAgentType = undefined;

var _agentTypes = require('../../pubnub-message/constants/agentTypes');

var _senderTypes = require('../../pubnub-message/constants/senderTypes');

var senderTypeToAgentType = exports.senderTypeToAgentType = function senderTypeToAgentType(senderType) {
  return senderType === _senderTypes.BOT ? _agentTypes.BOT : _agentTypes.HUMAN;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/operators/sender-type/senderTypeToAgentType.js
// module id = 815
// module chunks = 2 3